import React from "react";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
import { Pie, Bar } from "react-chartjs-2";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title
);

// Named export for the Pie chart
export function PieGraph({ data, options }) {
  const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "bottom" },
      title: { display: false },
    },
  };

  const hasData = data?.datasets?.[0]?.data?.some(val => Number(val) > 0);

  return (
    <div style={{ position: "relative", height: "280px", width: "100%", display: "flex", justifyContent: "center" }}>
      {!hasData && (
        <div style={{
          position: "absolute",
          top: "42%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "180px",
          height: "180px",
          borderRadius: "50%",
          backgroundColor: "#fafafa",
          border: "2px dashed #cfcfcf",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#9e9e9e",
          fontSize: "14px",
          fontWeight: 500,
          zIndex: 0,
          boxShadow: "inset 0 0 10px rgba(0,0,0,0.02)"
        }}>
          No Data
        </div>
      )}
      <div style={{ position: "relative", zIndex: 1, height: "100%", width: "100%" }}>
        <Pie data={data} options={options || defaultOptions} />
      </div>
    </div>
  );
}

// Named export for the Bar chart
export const BarGraph = ({ data, options }) => {
  const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
      title: {
        display: false,
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false
        }
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grid: {
          color: 'rgba(0,0,0,0.05)'
        }
      },
    },
    barThickness: 50,
    categoryPercentage: 0.8,
    barPercentage: 0.9,
  };

  return (
    <div style={{ height: '350px', width: '100%' }}>
      <Bar data={data} options={options || defaultOptions} />
    </div>
  );
};